import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "../../../../../Components/Panel/Panel";
import { InputGroup, Input, InputGroupAddon, Button, Alert } from "reactstrap";
import Pagination from "../../../../../Components/Pagination/QSP";
import { currencyName } from "../../../../../Components/User/UserNames";
import qs from "qs";
import downloadExcel from "../../downloadExcel";
import LocationModal, {
  getDistance,
  hasCoords,
  distanceText,
  ALLOW_DISTANCE,
} from "../../LocationModal";

import ReactMoment from "react-moment";

const STATUS_FILTERS = [
  { value: "", label: "전체" },
  { value: "C", label: "적립완료" },
  { value: "D", label: "취소" },
];

export default ({
  location,
  page,
  gruSavingInfo,
  commonStatus,
  keyword,
  keywordInput,
  blockSize,
  first,
  data,
  loading,
  baseUrl,
  handleSearch,
  handleCancel,
}) => {
  const queryString = qs.parse(location.search.substr(1));

  // 지도 모달 — 선택한 적립내역 1건을 보여준다.
  const [locationItem, setLocationItem] = useState(null);

  const onDownload = () =>
    downloadExcel(
      "gruSavings",
      {
        gruSavingInfo,
        commonStatus,
        keyword,
        startDate: queryString.startDate,
        endDate: queryString.endDate,
      },
      "NFC 적립내역.xlsx"
    );

  // 좌표 숫자는 읽어도 의미가 없어 거리와 지도 버튼으로 대체한다.
  const renderLocation = (item) => {
    const scanOk = hasCoords(item.longitude, item.latitude);
    if (!scanOk) {
      // 위치 검증을 켠 적립정보인데 좌표가 없다 = 앱이 좌표를 못 받았다는 뜻.
      // (권한 거부 · 위치 서비스 꺼짐 · 실내 미확보) 적립은 그대로 처리된다.
      return item.gruSavingInfo?.isLocationCheck ? (
        <span className="label label-warning">위치 권한 비활성</span>
      ) : (
        <span className="f-s-12 text-muted">검증 미사용</span>
      );
    }

    const storeOk = hasCoords(item.store?.longitude, item.store?.latitude);
    const distance = storeOk
      ? getDistance(
          parseFloat(item.store.latitude),
          parseFloat(item.store.longitude),
          parseFloat(item.latitude),
          parseFloat(item.longitude)
        )
      : null;

    return (
      <>
        {distance !== null && (
          <span
            className={`m-r-5 ${
              distance > ALLOW_DISTANCE ? "text-danger f-w-600" : ""
            }`}
          >
            {distanceText(distance)}
          </span>
        )}
        <button
          type="button"
          className="btn btn-white btn-xs text-blue"
          onClick={() => setLocationItem(item)}
        >
          지도
        </button>
      </>
    );
  };

  return (
    <>
      <Helmet>
        <title>NFC 적립내역 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Home</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link to="/gruSavings">NFC 적립</Link>
          </li>
          <li className="breadcrumb-item active">적립내역</li>
        </ol>
        <h1 className="page-header">NFC 적립내역</h1>

        <div className="row m-b-15">
          <div className="col-xs-12 text-left">
            <Link to="/gruSavings" className="btn btn-white m-r-5">
              적립정보 목록
            </Link>
            <button
              type="button"
              className="btn btn-white"
              onClick={onDownload}
            >
              <i className="fa fa-download m-r-5"></i>엑셀 다운로드
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            {loading && (
              <div className="panel-loader">
                <span className="spinner-small"></span>
              </div>
            )}

            <Panel>
              <PanelHeader noButton={true}>
                적립내역({!loading && data.AdminGruSavingList.count}건 / 합계{" "}
                {!loading &&
                  (data.AdminGruSavingList.totalAmount || 0).toLocaleString()}
                )
              </PanelHeader>
              <Alert className="bg-gray-transparent-1">
                <div>
                  {STATUS_FILTERS.map((item) => {
                    const url =
                      "?" +
                      (gruSavingInfo
                        ? "gruSavingInfo=" + gruSavingInfo + "&"
                        : "") +
                      (item.value ? "commonStatus=" + item.value + "&" : "") +
                      (keyword ? "keyword=" + keyword + "&" : "");
                    return (
                      <Link
                        key={item.value}
                        className={`btn btn-white m-r-5 m-b-5 ${
                          (queryString.commonStatus || "") === item.value
                            ? "active"
                            : ""
                        }`}
                        to={`/gruSavingList${url}`}
                      >
                        {item.label}
                      </Link>
                    );
                  })}
                </div>
                <form onSubmit={handleSearch}>
                  <InputGroup>
                    <Input
                      type="text"
                      className="input-white"
                      placeholder="검색어(가맹점명, 회원명, 아이디) 입력"
                      value={keywordInput.value}
                      onChange={keywordInput.onChange}
                    />
                    <InputGroupAddon addonType="append">
                      <Button size="sm" color="white">
                        <i className="fa fa-search fa-fw"></i>
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </form>
              </Alert>
              {!loading && data.AdminGruSavingList.count > 0 ? (
                <>
                  <PanelBody>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped m-b-0">
                        <thead>
                          <tr>
                            <th>상태</th>
                            <th>가맹점명</th>
                            <th>적립정보</th>
                            <th>회원</th>
                            <th>적립 금액</th>
                            <th>스캔 위치</th>
                            <th>적립일시</th>
                            <th>기능</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.AdminGruSavingList.gruSavings.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td>
                                  {item.commonStatus === "C" && "적립완료"}
                                  {item.commonStatus === "D" && (
                                    <span className="text-danger">취소</span>
                                  )}
                                </td>
                                <td>{item.store.name}</td>
                                <td>{item.gruSavingInfo.name}</td>
                                <td>
                                  {item.user.name}({item.user.userId})
                                </td>
                                <td className="text-right">
                                  {item.amount.toLocaleString()}
                                  {currencyName(item.currency)}
                                </td>
                                <td>{renderLocation(item)}</td>
                                <td>
                                  <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                                    {item.createdAt}
                                  </ReactMoment>
                                </td>
                                <td>
                                  {item.commonStatus === "C" && (
                                    <button
                                      type="button"
                                      className="btn btn-white btn-xs text-danger"
                                      onClick={() => handleCancel(item.id)}
                                    >
                                      적립취소
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </PanelBody>
                  <PanelFooter>
                    <div className="row">
                      <div className="col-md-6">
                        <Pagination
                          totalRecord={data.AdminGruSavingList.count}
                          blockSize={blockSize}
                          pageSize={first}
                          currentPage={page}
                          baseUrl={baseUrl}
                        />
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </PanelFooter>
                </>
              ) : (
                <PanelBody>
                  <p className="text-center">등록된 데이터가 없습니다.</p>
                </PanelBody>
              )}
            </Panel>
          </div>
        </div>
      </div>

      <LocationModal
        isOpen={!!locationItem}
        toggle={() => setLocationItem(null)}
        gruSaving={locationItem}
      />
    </>
  );
};
